import { APIClient } from '@frontend/api-utils';

export class PackageEnumClient extends APIClient {
    public static readonly endpoint = '/package-api/v1';

    public static async fetchPackageStates(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/package-states`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchPackageTriggers(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/package-triggers`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchPackageActions(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/package-actions`);
        return await this.handleResponse<string[]>(response);
    }
}
